var $ = jQuery;
var main = {};
var win = $(window);
var doc = $(document);

main = {
  defaults: {
  },
  onInit: function() {
    var vm = this;

    vm.toggleColorSwitcher()
    vm.showProductSizes()
    vm.hideQuickbuyPanel()
    vm.swatchHoverListener()
    vm.swatchClickListener()
    vm.quickBuyListener()
    vm.deselectColorSwatches()
    vm.toggleNewsletterSubmitBtn()
    vm.validateDateFormat()
    vm.playYoutubeVideo()
    vm.onSelectSize()
    vm.removePreselectedSize()
    vm.packSizeRedirect()

    this.onResize()
  },
  onLoad: function(e) {
    var vm = this;

    $('.product__thumbnails').on('init', function(event, slick){
      vm.assignImageDataAttr()
      vm.imageColorSelection()
    });

    setTimeout(function() {
      vm.preselectVariant()
    }, 1000)
  },
  onResize: function(e) {
    var vm = this;
    vm.showQuickbuyPanel()
  },
  showProductSizes: function() {
    const trigger = $('.quick-buy__trigger'),
          options = $('.quick-buy__size')

    doc.on('click', '.quick-buy__trigger', function() {
      $(this).next(options).slideToggle('fast')
      $(this).parent().toggleClass('expanded')
    })
  },
  hideQuickbuyPanel: function() {
    const vm = this
    const card = $('.product-card')

    doc.on('mouseleave', '.product-card', function() {
      const _this = $(this)
      const options = _this.find($('.quick-buy__size'))
      const panel = _this.find($('.quick-buy__panel'))

      if( options.is(':visible') ) {
        options.slideUp()
        panel.removeClass('expanded')
      }
      panel.css('bottom', '-50px')
    })
  },
  showQuickbuyPanel: function() {
    const vm = this
    const card = $('.product-card')

    if( win.innerWidth() > 1025 ) {
      doc.on('mouseenter', '.product-card', function() {
        const panel = $(this).find('.quick-buy__panel')
        const labelWrapper = $(this).find('.product-label__wrapper');
        let bottomPosition = labelWrapper.length ? labelWrapper.height() + 15 : 9;
        
        panel.css('bottom', bottomPosition + 'px');
      })
    }
  },

  /**
   * Deselect color swatches after mouse out
   */
  deselectColorSwatches: function() {
    const card = $('.product-card');

    doc.on('mouseleave', '.product-card', function() {
      const _this = $(this);
      let sizes = _this.find('.size-options span'),
          swatches = _this.find('.swatch'),
          selectedColor = _this.find('.swatch:first-child').data('color-title'),
          productImg = _this.find('.variant-option__image:first-child'),
          altProductImg = _this.find('.variant-option__image:nth-child(2)'),
          optionImg = _this.find('.variant-option__color'),
          colors = _this.find('.swatch')
      
      /** Deselect color swatches */
      swatches.removeClass('selected')
      productImg.css('opacity', 1)
      optionImg.css('opacity', 0)
      altProductImg.removeAttr('style')
      
      colors.each(function() {
        var self = $(this)
        if( self.hasClass('preselected') ) {
          self.addClass('selected')
        }
      })

      /** Show the sizes of first color in Quick buy panel */
      if( !_this.find('.swatch.preselected').length ) {
        sizes.each(function() {
          var color = $(this).data('color')
          if( color == selectedColor ) {
            $(this).show()
          } else {
            $(this).hide()
          }
        })
      }

    })
  },

  /**
   * Handles color selection functionality
   */
  swatchClickListener: function() {
    const option = $('')

    doc.on('click', '.product-card .swatch', function() {
      const _this = $(this)
      let color = _this.attr('data-color-title').replace(/\s/g, '-').replace('/', '-').toLowerCase()
      const productCard = _this.closest('.product-card');
      let optionImg = productCard.find('.variant-option__color')
      let productImg = productCard.find('.variant-option__image')
      let selectedOptionImg = productCard.find(`.variant-option__color.color-${color}`)
      
      if( !productCard.hasClass('clicked') ) {
        productCard.addClass('clicked')
      }

      productCard.find(option).removeClass('selected')
      _this.addClass('selected')

      productImg.css('opacity', 0)
      optionImg.css('opacity', 0)
      selectedOptionImg.css('opacity', 1)

      main.toggleColorSwitcher()
    })
  },

  /**
   * Handles color roll over functionality
   */
  swatchHoverListener: function() {
    doc.on('mouseenter', '.product-card .swatch' , function() {
      const _this = $(this)
      const option = $('.product-card .swatch')
      let color = _this.attr('data-color-title').replace(/\s/g, '-').replace('/', '-').toLowerCase()
      const productCard = _this.closest('.product-card');
      let optionImg = productCard.find('.variant-option__color')
      let productImg = productCard.find('.variant-option__image')
      let selectedOptionImg = productCard.find(`.variant-option__color.color-${color}`)

      _this.parent('.product-card__color-options').find(option).removeClass('selected')
      _this.addClass('selected')

      productImg.css('opacity', 0)
      optionImg.css('opacity', 0)
      selectedOptionImg.css('opacity', 1)

      main.toggleColorSwitcher()
    })
  },
  /**
   * Handles quick buy functionality
   */
  quickBuyListener: function() {
    const option = $('.size-options span')
    const variants = $('.variant-options')

    doc.on('click', '.size-options span', function() {
      option.removeClass('clicked')
      $(this).addClass('clicked')

      let parent = $(this).closest('.product-card');
      let selectedVariant = $(this).data('size-title');
      let variantSelection = parent.find('.variant-options');
      let id = variantSelection.find(`option[data-size-title="${selectedVariant}"]`).attr('value');
      
      $.ajax({
        method: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: id
        },
        dataType: 'json',
        async: false,
        success: function() {
          theme.cart.openCartDrawer();
          theme.cart.fetchData(function () {
            theme.cart.updateBadges();
            theme.cart.updateCartItems();
            theme.cart.updateSubtotal();
          });
        },
        error: function(response) {
          console.log('error', response)
        },
        complete: function() {
          setTimeout(function() {
            theme.cart.closeCartDrawer();
          }, 2000)
        }
      });
    })
  },
  toggleColorSwitcher: function() {
    var card = $('.product-card')

    card.each(function() {
      var _this = $(this);
      var colors = _this.find('.swatch')
      var selectedColor = (  _this.find('.swatch.selected').length ) ? _this.find('.swatch.selected').data('color-title') : _this.find('.swatch:first-child').data('color-title')
      var sizes = _this.find('.size-options span');
      var variantImgs = _this.find('.variant-option__image ')
      var selectedColorHandle = String(selectedColor).replace(/\s/g, '-').replace('/', '-').toLowerCase();
      var selectedVariantImg = _this.find(`.variant-option__color.color-${ selectedColorHandle }`)

      // colors.each(function() {
      //   if( $(this).hasClass('preselected') ) {
      //     variantImgs.css('opacity', 0)
      //     selectedVariantImg.css('opacity', 1)
      //   } 
      // })
      
      sizes.each(function() {
        var self = $(this);
        var color = self.data('color');
        var regExp = /\(([^)]+)\)/;
        var matches = regExp.exec(self.text());
        var substring = self.text().replace(color, '').replace(' / ', '')

        if( color == selectedColor ) {
          self.show()
        } else {
          self.hide()
        }

        if( matches ) {
          self.text( substring.replace(matches[0], '') )
        } else {
          self.text(substring)
        }

        var varTitle = self.text().toLowerCase()

        if (varTitle.indexOf("mths") >= 0) {
          self.text( self.text().replace('mths', 'M').replace('MTHS', 'M') )
        } else if(varTitle.indexOf("newborn") >= 0) {
          self.text( self.text().replace('newborn', 'NB').replace('Newborn', 'NB').replace('NEWBORN', 'NB') )
        } else if(varTitle.indexOf("one size") >= 0) {
          self.text( self.text().replace('One Size', 'OS') )
        }

      })
    })
  },
  validateDate: function(date) {
    var regex = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])$/;
    return date.match(regex)
  },
  validateMonth: function(date) {
    var separatedDate = date.split('/')
    var month = separatedDate[1]
    var day = separatedDate[0]

    // console.log('month', month)
    // console.log('day', day)
    // console.log('condition', [04, 06, 09, 11].includes(parseInt(month)))

    if( month == 02 ) {
      return day <= 29 ? true : false;
    } else if( [04, 06, 09, 11].includes(parseInt(month)) ) {
      return day <= 30 ? true : false;
    } else {
      return true;
    }

  },
  validateDateFormat: function(date) {
    var vm = this
    var regex = /^[0-9\/]*$/
    var bday = $('#k_id_bday')
    
    bday.on('keyup, keypress', function(e) {
      var _this = $(this)
      var val =_this.val()
      var valCount = val.length
      var key = e.which || e.keyCode || 0;

      (key < 48 || key > 57) ? e.preventDefault() : null
      if( valCount == 2 ) {
       _this.val( val + '/' )
      } else if( valCount >= 5 ) {
        e.preventDefault();
      }
    
    })
  },
  toggleNewsletterSubmitBtn: function() {
    var bday = $('#k_id_bday')
    var fields = $("#footer_email_signup input");
    var btn = $('#newsletter-submit')
    var vm = this

    fields.keyup(() => {
      var isValidBday = () => {
        if ( vm.validateDate(bday.val()) != null && vm.validateMonth(bday.val()) ) {
          bday.parent().removeClass('invalid')
          return true;
        } else {
          bday.parent().addClass('invalid')
          return false;
        }
      }
      isValidBday()
      var isValidMonth = vm.validateMonth(bday.val());
      var isValidFields = fields.filter(function () {
        return $.trim($(this).val()).length == 0
      }).length == 0;

      isValidMonth & isValidFields && isValidBday() ? btn.removeAttr('disabled') : btn.attr('disabled', 'disabled')
    })
  },

  playYoutubeVideo: function() {
    var video = $('.youtube-video');

    video.on('click', function(e) {
      var _this = $(this);
      _this.find('iframe')[0].src += "&autoplay=1";

      _this.addClass('played')

      e.preventDefault()
    })
    
  },

  onSelectSize: function() {
    var sizeOpt = $('.option-group__size .variant-group__item')
    sizeOpt.click(function() {
      var value = $(this).attr('data-value')
      sizeOpt.removeClass('selected')
      $(`.option-group__size .variant-group__item[data-value="${value}"]`).addClass('selected')

      console.log('value', value)
      $('.size-validation').hide()
      $('.option-group__size .variant-group__variant').html(value)
    })
  },

  assignImageDataAttr: function() {
    var thumbnail = $('.product__thumbnails .product__thumbnail')
    var color = '';
    thumbnail.each(function() {
      if( $(this).attr('data-variant') ) {
        color = $(this).attr('data-variant')
      } else {
        $(this).attr('data-variant', color)
      }
    })
  },

  imageColorSelection: function() {
    var thumbnail = $('.product__thumbnails .product__thumbnail')
    var hasColour = $('.option-group__colour, .option-group__color').length

    console.log('hasColour', hasColour)
    if( hasColour > 0 ) {

      // Switch selected variant color upon clicking the product thumbnail
      thumbnail.click(function() {
        var color = $(this).attr('data-variant');
        if( color != '' ) {
          $(`.variant-group__item input[data-title=${color}]`).trigger('click')
        }
      })

      // Trigger click when using slick arrows
      $('.product__thumbnails').on('afterChange', function(event, slick, currentSlide){
        var current = $(`.product__thumbnails .product__thumbnail[data-slick-index=${currentSlide}]`)
        current.trigger('click')
      });

    }
    
  },

  removePreselectedSize: function() {
    var hasVariant = window.location.search.indexOf('variant')
    if( $('body').hasClass('template-product') ) {
      if( hasVariant < 1 ) {
        $('.option-group__size input')
          .attr('checked', false)
          .parent().removeClass('selected')
      } else {
        //variant-group__variant
        $('.option-group__size .variant-group__variant').html($('.option-group__size input:checked').val())
      }
    }
  },

  packSizeRedirect: function() {
    var variant = $('.variant-group__single label')
    variant.click(function() {
      var url = $(this).attr('data-url');
      var queryParams = '';
      var path = document.location.pathname.split('/');

      $('.variant-group__item input:checked').each(function(index, value) {
        var value = $(this).attr('data-title'), type = $(this).attr('data-option')
        var isLastElement = index == $('.variant-group__item input:checked').length -1;
        queryParams += (isLastElement) ? `${type}=${value}` : `${type}=${value}&` 
      })
      
      variant.removeClass('active')
      $(this).addClass('active')

      if( path[path.length - 1] != url ) {
        window.location.href= `${url}?${queryParams}`
      }

    })
  },

  preselectVariant: function() {
    if(document.location.search.length) {
      var color = '', size = '';
      var urlParams = new URLSearchParams(window.location.search);
      var params = document.location.search

      if (params.indexOf("color") >= 0) {
        color = urlParams.get('color')
        $(`.variant-group__item input[data-title=${color}]`).trigger('click')
      } 
      
      if (params.indexOf("colour") >= 0) {
        color = urlParams.get('colour')
        $(`.variant-group__item input[data-title=${color}]`).trigger('click')
      } 
      
      if (params.indexOf("size") >= 0) {
        size = urlParams.get('size')
        $(`.variant-group__item input[data-title=${size}]`).trigger('click')
        $(`.variant-group__item input[data-title=${size}]`).parent().addClass('selected')
      }

      console.log('color', color)
      console.log('size', size)
    }

  },


};

doc.ready(function() {
  main.onInit();
});

win.on('load', function() {
  main.onLoad();
});

win.resize(function() {
  main.onResize();
});
